import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import { TableDataModel } from '@app/shared/models';
import { TablePaginationModel } from '@app/shared/models/table/table-pagination.model';
import { TableSortingModel } from '@app/shared/models/table/table-sorting.model';
import { parse } from '@app/shared/utilities/url-search-params-parser';
import { Observable } from 'rxjs';
import { BlogCategoryTableItemModel, BlogCategoryCreateModel, BlogCategoryUpdateModel, BlogCategoryChangeSequenceModel } from "@app/modules/blog-category/models";

@Injectable({
	providedIn: 'root',
})
export class BlogCategoryService {
	private readonly endpoints = {
		get: 'BlogCategory/:id',
		overview: 'BlogCategory/GetOverview',
		update: 'BlogCategory/Update',
		create: 'BlogCategory/Create',
		delete: 'BlogCategory/Delete?id=:id',
		changeSequence: 'BlogCategory/ChangeSequence',
	};

	constructor(private readonly httpService: HttpService) {}

	getAll(
		sorting: TableSortingModel,
		pagination: TablePaginationModel
	): Observable<TableDataModel<BlogCategoryTableItemModel>> {
		const paginationParams = parse(pagination, 'pagination');
		const sortingParams = parse(sorting, 'sorting');

		return this.httpService.get<any>(this.endpoints.overview + `?${paginationParams}&${sortingParams}`);
	}

	get(id: number): Observable<BlogCategoryUpdateModel> {
		return this.httpService.get<any>(this.endpoints.get.replace(':id', id.toString()));
	}

	update(request: BlogCategoryUpdateModel): Observable<BlogCategoryUpdateModel> {
		return this.httpService.put<any>(this.endpoints.update, request);
	}

	create(request: BlogCategoryCreateModel): Observable<BlogCategoryUpdateModel> {
		return this.httpService.post<any>(this.endpoints.create, request);
	}

	delete(id: number): Observable<any> {
		return this.httpService.delete<any>(this.endpoints.delete.replace(':id', id.toString()));
	}

	changeSequence(request: BlogCategoryChangeSequenceModel): Observable<any> {
		return this.httpService.put<any>(this.endpoints.changeSequence, request);
	}
}
